import { createSelector } from '@reduxjs/toolkit';
import { deviceHistoriesAdapterSelectors } from '../redux/slices/deviceHistories';
import { devicesAdapterSelectors } from 'src/redux/slices/devices';

export const getDeviceHistories = createSelector(
  (state) => deviceHistoriesAdapterSelectors.selectAll(state),
  (state) => devicesAdapterSelectors.selectAll(state),
  (deviceHistories, devices) => {
    return deviceHistories.map((deviceHistory) => ({
      ...deviceHistory,
      device: devices.find((device) => device.id === deviceHistory.deviceId),
    }));
  }
);

export const getLastDeviceHistories = createSelector(
  getDeviceHistories,
  (deviceHistories) => {
    const deviceHistoriesSorted = deviceHistories.sort(
      (a, b) => new Date(b.receivedAt) - new Date(a.receivedAt)
    );
    return deviceHistories.length > 200
      ? deviceHistoriesSorted.slice(0, 200)
      : deviceHistoriesSorted;
  }
);
